// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d2835132","952":"6a97d811"}[chunkId] + ".chunk.js";
};